import { Asleep, Awake } from '@carbon/icons-react';
import { Fade, FormControlLabel, Tooltip } from '@mui/material';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import IosToggle from '../../ios-toggle/IosToggle';
import { useStyles } from './styles';

type Props = {
    toggleTheme: any;
    bodyTheme: string;
};

const ThemeToggle = ({ toggleTheme, bodyTheme }: Props) => {
    const classes = useStyles();
    const [t] = useTranslation();

    return (
        <div className={classes.toggleWrapper}>
            <Tooltip
                classes={{
                    tooltip: classes.tooltip,
                }}
                title={t('CUSTOMER_SETTINGS.DARKMODE_TOOLTIP')}
                placement="left-start"
                TransitionComponent={Fade}
            >
                <Asleep />
            </Tooltip>
            {bodyTheme === 'light' && (
                <FormControlLabel label="" control={<IosToggle checked={true} onChange={toggleTheme} name="theme-toggle" />} />
            )}
            {bodyTheme === 'dark' && (
                <FormControlLabel label="" control={<IosToggle checked={false} onChange={toggleTheme} name="theme-toggle" />} />
            )}
            <Tooltip
                classes={{
                    tooltip: classes.tooltip,
                }}
                title={t('CUSTOMER_SETTINGS.LIGHTMODE_TOOLTIP')}
                placement="left-start"
                TransitionComponent={Fade}
            >
                <Awake />
            </Tooltip>
        </div>
    );
};

export default ThemeToggle;
